import { getClinicalDataApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { ClinicalDataListResponse } from './types/types';

export const listClinicalData = async (user_id: number, userRole?: string): Promise<ClinicalDataListResponse> => {
  const prefix = getClinicalDataApiPrefix(userRole);
  const endpoint = prefix ? `${prefix}/clinical_data/${user_id}` : `/clinical-data/${user_id}`;
  const { data } = await client.get<ClinicalDataListResponse>(endpoint);

  return data;
};
